/**
 * The manual-order due pill's words and colour (Phase 104, D-14), as data.
 *
 * Colour comes from the shared `dueUrgency` rule (the same one the backend's
 * Ready-tab sort is documented against): red when overdue or due within 2
 * days, amber within the week, plain after that. Words: "Overdue", "Today",
 * "Tomorrow", or a short date. Both dates are plain calendar days
 * (`YYYY-MM-DD`); `today` is the browser's own local date.
 */
import { dueUrgency, type DueUrgency } from '@threadheads/shared';
import { daysUntil } from './build-payload';

export type DueWord = 'overdue' | 'today' | 'tomorrow' | 'date';

export interface DuePillModel {
  urgency: DueUrgency;
  word: DueWord;
}

/** Null when there is no due date or it is malformed (no pill). */
export function duePillModel(dueDate: string | null | undefined, today: string): DuePillModel | null {
  const urgency = dueUrgency(dueDate, today);
  if (!urgency || !dueDate) return null;
  const days = daysUntil(today, dueDate);
  if (days === null) return null;
  const word: DueWord = days < 0 ? 'overdue' : days === 0 ? 'today' : days === 1 ? 'tomorrow' : 'date';
  return { urgency, word };
}
